export const HERO_AUTOPLAY_DURATION = 4000;
export const ACTION_AUTOPLAY_DURATION = 6000;
export const LIKES_AUTOPLAY_DURATION = 5000;
export const WATCH_LIST_AUTOPLAY_DURATION = 8000;
export const JUST_RELEASE_AUTOPLAY_DURATION = 9000;
export const POPULAR_AUTOPLAY_DURATION = 6000;
export const TOP_CASTS_AUTOPLAY_DURATION = 4000;
export const RECOMMENDATION_AUTOPLAY_DURATION = 6000;
export const TOAST_VISIBILITY_DURATION = 1500;
export const TOAST_THEME = "dark";
